import BaseModel from './base';
import { DEFAULT_NOMINATION } from '@/modules/Events/constants.js';
import Group from './group';
import { smartNumberSort } from '@/modules/UIDesign/functions';
import NominationOptions from './nomination-options';

export default class Nomination extends BaseModel {
  constructor(nomination = {}, url) {
    super(nomination, url);

    this.id = nomination.id;
    this.deletion_process = nomination.deletion_process || null;
    this.name = nomination.name === DEFAULT_NOMINATION.KEY ? DEFAULT_NOMINATION.NAME : nomination.name;
    this.original_name = nomination.original_name ?? null;
    this.groups = smartNumberSort((nomination.groups || []).map((group) => new Group(group, 'event-groups')), 'name');
    this.can_request = nomination.can_request ?? true;
    // from /events/:id expand: 'nominations'
    this.image = nomination?.image || null;
    // from /nominations
    this.directory_nomination_id = nomination?.directory_nomination_id || null;

    this.options = nomination.options ? new NominationOptions(nomination.options) : null;
  }

  get isBase() {
    return this.name === DEFAULT_NOMINATION.NAME;
  }

  get isDeleting() {
    return !!this.deletion_process;
  }

  get hasGroups() {
    return !!this.groups.length;
  }

  get baseGroup() {
    return this.groups.find((group) => group.isBase);
  }

  get hasGroupsWithoutBase() {
    const groupsWithoutBase = this.groups.filter((group) => !group.isBase);
    return !!groupsWithoutBase.length;
  }

  get actualGroups() {
    if (this.groups.length > 1) {
      return this.groups.filter((group) => !group.isBase);
    }
    return this.groups;
  }

  get groupsByTasks() {
    return this.groups.filter(
      (group) => group.hasSomeTask,
    );
  }
}
